import { formatThousands } from '../../../utils/format/formatNumber';
import { getCompareResult } from '../utils/getCompareResult';
import * as S from './SummaryCard.style';

export default function SummaryCard({ summary, previous, current, dateType }) {
    const { title, unit, apiKeys, route, routeLabel } = summary;

    const compareValues = () => {
        if (!apiKeys || apiKeys.length === 0) return [null, null];
        let currentValue = current;
        let previousValue = previous;
        let previousValue2 = previous;
        let currentValue2 = current;

        if (!previous) {
            //날짜 지정으로 previous 값이 없을 때
            for (let key of apiKeys) {
                currentValue = currentValue[key];
            }
            if (summary.apiKeys2) {
                for (let key of summary.apiKeys2) {
                    currentValue2 = currentValue2[key];
                }
            }
            return [currentValue, null, currentValue2, null];
        }

        for (let key of apiKeys) {
            currentValue = currentValue[key];
            previousValue = previousValue[key];
        }

        if (summary.apiKeys2) {
            for (let key of summary.apiKeys2) {
                currentValue2 = currentValue2[key];
                previousValue2 = previousValue2[key];
            }
        }

        if (!summary.apiKeys2) {
            currentValue2 = null;
            previousValue2 = null;
        }
        return [currentValue, previousValue, currentValue2, previousValue2];
    };
    const [currentValue, previousValue, currentValue2, previousValue2] = compareValues();
    const { state, compareDescription } = getCompareResult(currentValue, previousValue, unit, dateType, currentValue2, previousValue2);

    const value = summary.apiKeys2 ? `${formatThousands(currentValue, unit)}/${formatThousands(currentValue2, unit)}` : `${formatThousands(currentValue, unit)}`;

    const routeLabelText = routeLabel ? routeLabel : value;

    return (
        <S.SummaryCard>
            <S.Title>{title}</S.Title>
            {route ? (
                <>
                    {route(routeLabelText)}
                    {compareDescription && <S.Description $state={state}>{compareDescription}</S.Description>}
                </>
            ) : (
                <>
                    <S.Result>{value}</S.Result>
                    {compareDescription && <S.Description $state={state}>{compareDescription}</S.Description>}
                </>
            )}
        </S.SummaryCard>
    );
}
